import React from 'react';

export default function Footer() {
  return (
    <footer>
      Population data is based on the{' '}
      <a href="https://population.un.org/wpp/" target="_blank" rel="noreferrer">
        United Nations World Population Prospects.
      </a>
      <br />
      Income groups are based on{' '}
      <a
        href="https://datatopics.worldbank.org/world-development-indicators/the-world-by-income-and-region.html"
        target="_blank"
        rel="noreferrer"
      >
        World Bank
      </a>{' '}
      classifications.
      <br />
      Vaccine data is from{' '}
      <a
        href="https://ourworldindata.org/covid-vaccinations"
        target="_blank"
        rel="noreferrer"
      >
        Our World in Data
      </a>{' '}
      (automatically updated daily from source)
      <br />
    </footer>
  );
}
